export default __webpack_public_path__ + "static/media/6.a6f3ea89.JPG";